/* eslint-disable no-lone-blocks */
import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
const QuestionListSkeleton = (props: any) => {
  return (
    <React.Fragment>
      <SkeletonTheme
        color="rgba(255, 0, 158, 0.05)"
        highlightColor="rgba(255, 0, 158, 0.05)"
      >
        <Skeleton
          duration={2}
          count={props.count ? props.count : 4}
          width={`100%`}
          height={30}
        />
      </SkeletonTheme>
    </React.Fragment>
  )
}
export default QuestionListSkeleton
